import { createDataSelector, createIsRequestedSelector, createSonarSelector } from '@lib/selectors';

export const sonarObjectSearchStateSelector = createSonarSelector((state) => state.core.sonarObjects.search.get);

export const isSonarObjectSearchLoadingSelector = createIsRequestedSelector(sonarObjectSearchStateSelector);

export const sonarObjectsSearchDataSelector = createDataSelector(sonarObjectSearchStateSelector);
